<vrm-page-container>
  <vrm-mentor-reports
    *ngIf='commonReportReady'
    [reportTitle]='reportTitle'
    [metadata]='reportMeta'
    [serverSideRendering]='ssrOptions'
    [rawData]='rawReportsData'
    [pinnedTopRowData]='pinnedTopRowData'
    [pinnedBottomRowData]='pinnedBottomRowData'
    [multiRowSelection]='multiRowSelection'
    [reportOptions]='rptOptions'
    [primaryKey]='primaryKey'
    [canDrilldownToDriverPerformanceRecord]='canDrilldownToDriverPerformanceRecord'
    (makeRowEditable)='makeSelectedRowEditableViaDialog($event)'
    (administerMisContent)='administerMisContentDialog($event)'
  ></vrm-mentor-reports>
</vrm-page-container>
